import { datadogRum } from '@datadog/browser-rum';
import { logError } from '~/utilities/loggers';
import showApiError from './showApiError';

export function reportFetchFailure(location: string, toastMessage?: string) {
  logError(new Error(`${location} request failed`), { location });
  showApiError(toastMessage);
}

export function reportActionFailure(
  event: string,
  location: string,
  error?: string
) {
  datadogRum.addAction(event, { error });
  reportFetchFailure(location);
}
